/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MasterItemUpdateBase
 */
export interface MasterItemUpdateBase {
    /**
     * 
     * @type {boolean}
     * @memberof MasterItemUpdateBase
     */
    deleteFlg?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof MasterItemUpdateBase
     */
    insertDatetime?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MasterItemUpdateBase
     */
    insertUser?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MasterItemUpdateBase
     */
    updateDatetime?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MasterItemUpdateBase
     */
    updateUser?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MasterItemUpdateBase
     */
    deleteDatetime?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MasterItemUpdateBase
     */
    deleteUser?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterItemUpdateBase
     */
    orgItemCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterItemUpdateBase
     */
    itemName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MasterItemUpdateBase
     */
    salesStartdate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof MasterItemUpdateBase
     */
    salesEnddate?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof MasterItemUpdateBase
     */
    longside?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MasterItemUpdateBase
     */
    shortside?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MasterItemUpdateBase
     */
    height?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MasterItemUpdateBase
     */
    weight?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MasterItemUpdateBase
     */
    spec?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MasterItemUpdateBase
     */
    maxPalletQuantity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MasterItemUpdateBase
     */
    palletQuantityFace?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MasterItemUpdateBase
     */
    palletQuantityTier?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MasterItemUpdateBase
     */
    jan?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterItemUpdateBase
     */
    janCase?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterItemUpdateBase
     */
    gtin13?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterItemUpdateBase
     */
    gtin14?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterItemUpdateBase
     */
    itf?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterItemUpdateBase
     */
    sdp?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterItemUpdateBase
     */
    replaceOrgItemCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterItemUpdateBase
     */
    makerGln?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterItemUpdateBase
     */
    makerName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterItemUpdateBase
     */
    orgSupplierId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterItemUpdateBase
     */
    orderUnitType?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MasterItemUpdateBase
     */
    caseLot?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MasterItemUpdateBase
     */
    minOrderQuantity?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof MasterItemUpdateBase
     */
    isDiscontinued?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MasterItemUpdateBase
     */
    isMuted?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof MasterItemUpdateBase
     */
    sortOrder?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MasterItemUpdateBase
     */
    remarks?: string | null;
}

/**
 * Check if a given object implements the MasterItemUpdateBase interface.
 */
export function instanceOfMasterItemUpdateBase(value: object): value is MasterItemUpdateBase {
    return true;
}

export function MasterItemUpdateBaseFromJSON(json: any): MasterItemUpdateBase {
    return MasterItemUpdateBaseFromJSONTyped(json, false);
}

export function MasterItemUpdateBaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MasterItemUpdateBase {
    if (json == null) {
        return json;
    }
    return {
        
        'deleteFlg': json['delete_flg'] == null ? undefined : json['delete_flg'],
        'insertDatetime': json['insert_datetime'] == null ? undefined : (new Date(json['insert_datetime'])),
        'insertUser': json['insert_user'] == null ? undefined : json['insert_user'],
        'updateDatetime': json['update_datetime'] == null ? undefined : (new Date(json['update_datetime'])),
        'updateUser': json['update_user'] == null ? undefined : json['update_user'],
        'deleteDatetime': json['delete_datetime'] == null ? undefined : (new Date(json['delete_datetime'])),
        'deleteUser': json['delete_user'] == null ? undefined : json['delete_user'],
        'orgItemCode': json['org_item_code'] == null ? undefined : json['org_item_code'],
        'itemName': json['item_name'] == null ? undefined : json['item_name'],
        'salesStartdate': json['sales_startdate'] == null ? undefined : (new Date(json['sales_startdate'])),
        'salesEnddate': json['sales_enddate'] == null ? undefined : (new Date(json['sales_enddate'])),
        'longside': json['longside'] == null ? undefined : json['longside'],
        'shortside': json['shortside'] == null ? undefined : json['shortside'],
        'height': json['height'] == null ? undefined : json['height'],
        'weight': json['weight'] == null ? undefined : json['weight'],
        'spec': json['spec'] == null ? undefined : json['spec'],
        'maxPalletQuantity': json['max_pallet_quantity'] == null ? undefined : json['max_pallet_quantity'],
        'palletQuantityFace': json['pallet_quantity_face'] == null ? undefined : json['pallet_quantity_face'],
        'palletQuantityTier': json['pallet_quantity_tier'] == null ? undefined : json['pallet_quantity_tier'],
        'jan': json['jan'] == null ? undefined : json['jan'],
        'janCase': json['jan_case'] == null ? undefined : json['jan_case'],
        'gtin13': json['gtin_13'] == null ? undefined : json['gtin_13'],
        'gtin14': json['gtin_14'] == null ? undefined : json['gtin_14'],
        'itf': json['itf'] == null ? undefined : json['itf'],
        'sdp': json['sdp'] == null ? undefined : json['sdp'],
        'replaceOrgItemCode': json['replace_org_item_code'] == null ? undefined : json['replace_org_item_code'],
        'makerGln': json['maker_gln'] == null ? undefined : json['maker_gln'],
        'makerName': json['maker_name'] == null ? undefined : json['maker_name'],
        'orgSupplierId': json['org_supplier_id'] == null ? undefined : json['org_supplier_id'],
        'orderUnitType': json['order_unit_type'] == null ? undefined : json['order_unit_type'],
        'caseLot': json['case_lot'] == null ? undefined : json['case_lot'],
        'minOrderQuantity': json['min_order_quantity'] == null ? undefined : json['min_order_quantity'],
        'isDiscontinued': json['is_discontinued'] == null ? undefined : json['is_discontinued'],
        'isMuted': json['is_muted'] == null ? undefined : json['is_muted'],
        'sortOrder': json['sort_order'] == null ? undefined : json['sort_order'],
        'remarks': json['remarks'] == null ? undefined : json['remarks'],
    };
}

export function MasterItemUpdateBaseToJSON(json: any): MasterItemUpdateBase {
    return MasterItemUpdateBaseToJSONTyped(json, false);
}

export function MasterItemUpdateBaseToJSONTyped(value?: MasterItemUpdateBase | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'delete_flg': value['deleteFlg'],
        'insert_datetime': value['insertDatetime'] == null ? value['insertDatetime'] : value['insertDatetime'].toISOString(),
        'insert_user': value['insertUser'],
        'update_datetime': value['updateDatetime'] == null ? value['updateDatetime'] : value['updateDatetime'].toISOString(),
        'update_user': value['updateUser'],
        'delete_datetime': value['deleteDatetime'] == null ? value['deleteDatetime'] : value['deleteDatetime'].toISOString(),
        'delete_user': value['deleteUser'],
        'org_item_code': value['orgItemCode'],
        'item_name': value['itemName'],
        'sales_startdate': value['salesStartdate'] == null ? value['salesStartdate'] : value['salesStartdate'].toISOString(),
        'sales_enddate': value['salesEnddate'] == null ? value['salesEnddate'] : value['salesEnddate'].toISOString(),
        'longside': value['longside'],
        'shortside': value['shortside'],
        'height': value['height'],
        'weight': value['weight'],
        'spec': value['spec'],
        'max_pallet_quantity': value['maxPalletQuantity'],
        'pallet_quantity_face': value['palletQuantityFace'],
        'pallet_quantity_tier': value['palletQuantityTier'],
        'jan': value['jan'],
        'jan_case': value['janCase'],
        'gtin_13': value['gtin13'],
        'gtin_14': value['gtin14'],
        'itf': value['itf'],
        'sdp': value['sdp'],
        'replace_org_item_code': value['replaceOrgItemCode'],
        'maker_gln': value['makerGln'],
        'maker_name': value['makerName'],
        'org_supplier_id': value['orgSupplierId'],
        'order_unit_type': value['orderUnitType'],
        'case_lot': value['caseLot'],
        'min_order_quantity': value['minOrderQuantity'],
        'is_discontinued': value['isDiscontinued'],
        'is_muted': value['isMuted'],
        'sort_order': value['sortOrder'],
        'remarks': value['remarks'],
    };
}

